import EnterpriseComponentAttributeMetadata from "../../EnterpriseComponentAttributeMetadata";
import EnterpriseComponentMetadata from "../../EnterpriseComponentMetadata";

// The kinds of edge an object may have. Configuration, not data: administered elsewhere and only
// PICKED from here, which is why every attribute is NoUpdate.
//
// A type names itself twice because an edge reads differently from each end -- "is a component of"
// one way, "has component" the other -- and the grid shows whichever phrasing suits the record the
// reader is standing on.
class ObjectRelationshipTypeEnterpriseComponentMetadata extends EnterpriseComponentMetadata {
    constructor() {
        super();

        this.name = "ObjectRelationshipType";
        this.defaultCacheSize = 100;

        // (name, NoCopy, NoUpdate, Required, RequiredForQuery, Picklist, Scale, Precision, Length, MinLength, Pattern, Type, DefaultValue, Computed)
        this.attributes["USID"] = new EnterpriseComponentAttributeMetadata("USID", false, true, true, false, null, null, null, 36, null, null, "UUID", null, false);
        this.attributes["Name"] = new EnterpriseComponentAttributeMetadata("Name", false, true, false, false, null, null, null, 100, null, null, "String", null, false);
        this.attributes["SourceRelationshipName"] = new EnterpriseComponentAttributeMetadata("SourceRelationshipName", false, true, false, false, null, null, null, 100, null, null, "String", null, false);
        this.attributes["TargetRelationshipName"] = new EnterpriseComponentAttributeMetadata("TargetRelationshipName", false, true, false, false, null, null, null, 100, null, null, "String", null, false);
    }
}

export default ObjectRelationshipTypeEnterpriseComponentMetadata;
